/* ============================================================
   GSH — Judge.me: samodejno stiskanje naloženih slik na ≤50 KB
   Ob izbiri slike v Judge.me obrazcu za mnenje (modal v3) sliko
   prestrežemo, jo stisnemo (zmanjšamo + JPEG kakovost) na ≤50 KB
   in jo vrnemo v <input> PREDEN jo Judge.me naloži.
   Tehnika: change v CAPTURE fazi → stopImmediatePropagation (Judge.me
   originala ne vidi) → async stiskanje → nastavimo input.files prek
   DataTransfer → sprožimo nov change z zastavico bypass (Judge.me dobi
   stisnjeno datoteko).
   ============================================================ */
(function () {
  var TARGET_BYTES = 50 * 1024; // 50 KB
  var DIMS = [1600, 1400, 1100, 900, 700, 550, 420, 320, 260];
  var QUALITIES = [0.85, 0.7, 0.55, 0.42, 0.32, 0.22, 0.15];

  function isImage(f) { return f && /^image\//.test(f.type) && !/^image\/svg/.test(f.type); }

  function loadImage(file) {
    return new Promise(function (res, rej) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () { URL.revokeObjectURL(url); res(img); };
      img.onerror = function (e) { URL.revokeObjectURL(url); rej(e); };
      img.src = url;
    });
  }

  // SINHRONO kodiranje prek toDataURL — ni odvisno od vidnosti strani
  // (asinhroni canvas.toBlob se pri skritem zavihku zaustavi).
  function drawScaledCanvas(img, dim) {
    var canvas = document.createElement('canvas');
    var scale = Math.min(1, dim / Math.max(img.width, img.height));
    canvas.width = Math.max(1, Math.round(img.width * scale));
    canvas.height = Math.max(1, Math.round(img.height * scale));
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff'; // JPEG nima prosojnosti
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas;
  }

  function dataUrlByteSize(durl) {
    var comma = durl.indexOf(',');
    var b64 = durl.slice(comma + 1);
    var pad = b64.charAt(b64.length - 1) === '=' ? (b64.charAt(b64.length - 2) === '=' ? 2 : 1) : 0;
    return Math.floor(b64.length * 3 / 4) - pad;
  }

  function dataUrlToFile(durl, name) {
    var comma = durl.indexOf(',');
    var bin = atob(durl.slice(comma + 1));
    var len = bin.length;
    var arr = new Uint8Array(len);
    for (var k = 0; k < len; k++) arr[k] = bin.charCodeAt(k);
    return new File([arr], name, { type: 'image/jpeg', lastModified: Date.now() });
  }

  function newName(orig) {
    return (String(orig || 'slika').replace(/\.[^.]+$/, '') || 'slika') + '.jpg';
  }

  // Vrne Promise<File> stisnjene slike (ali original, če stiskanje ni mogoče / je že manjša)
  function compress(file) {
    if (file.size <= TARGET_BYTES) return Promise.resolve(file); // že dovolj majhna
    return loadImage(file).then(function (img) {
      var lastUrl = null;
      for (var i = 0; i < DIMS.length; i++) {
        var canvas = drawScaledCanvas(img, DIMS[i]);
        for (var j = 0; j < QUALITIES.length; j++) {
          var durl = canvas.toDataURL('image/jpeg', QUALITIES[j]);
          lastUrl = durl;
          if (dataUrlByteSize(durl) <= TARGET_BYTES) {
            return dataUrlToFile(durl, newName(file.name));
          }
        }
      }
      return lastUrl ? dataUrlToFile(lastUrl, newName(file.name)) : file; // najmanjša dosežena
    }).catch(function () { return file; }); // ob napaki obdrži original
  }

  function matchesMediaInput(el) {
    if (!el || el.tagName !== 'INPUT' || el.type !== 'file') return false;
    if (el.classList && el.classList.contains('jdgm-write-review-modal__media-input')) return true;
    if (el.name === 'media' && el.closest && el.closest('.jdgm-write-review-modal')) return true;
    if (el.closest && el.closest('.jdgm-write-review-modal, .jdgm-form, .jdgm-review-widget-modal')) return true;
    return false;
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!matchesMediaInput(input)) return;
    if (input.__gshBypass) { input.__gshBypass = false; return; } // naš re-dispatch → spusti do Judge.me

    var files = Array.prototype.slice.call(input.files || []);
    if (!files.length) return;
    var imgs = files.filter(isImage);
    if (!imgs.length) return; // ni slik za stisniti
    // VAROVALKA proti zanki: če so vse slike že ≤ cilja (npr. naša stisnjena datoteka,
    // ali Judge.me ponovno sproži change), NE prestrezaj — samo spusti skozi.
    if (imgs.every(function (f) { return f.size <= TARGET_BYTES; })) return;

    // Prestrezi original: Judge.me ne sme dobiti nestisnjenih datotek
    e.stopImmediatePropagation();
    e.preventDefault();

    Promise.all(files.map(function (f) {
      return isImage(f) ? compress(f) : Promise.resolve(f);
    })).then(function (out) {
      try {
        var dt = new DataTransfer();
        out.forEach(function (f) { dt.items.add(f); });
        input.files = dt.files;
        input.__gshBypass = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (err) {
        // DataTransfer ni podprt (zelo star brskalnik) → pusti original skozi
        input.__gshBypass = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }, true); // CAPTURE
})();

/* ============================================================
   GSH — Judge.me: popravek nepopolnega SL prevoda v modalu
   Judge.me slovenski prevod ima ponekod češke/tuje ostanke
   (npr. ocena "Výborný"). Točne pojavitve popravimo na slovensko.
   ============================================================ */
(function () {
  var FIX = {
    'Výborný': 'Odlično',
    'Výborné': 'Odlično',
    'Špatný': 'Slabo',
    'Dobrý': 'Dobro'
  };
  function fixIn(root) {
    if (!root || !root.querySelectorAll) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      var raw = n.nodeValue;
      var key = raw.trim();
      if (FIX[key] !== undefined) { n.nodeValue = raw.replace(key, FIX[key]); }
    }
  }
  var scheduled = false;
  function run() {
    scheduled = false;
    var modal = document.querySelector('.jdgm-write-review-modal, .jdgm-review-widget-modal');
    if (modal) fixIn(modal);
  }
  function schedule() { if (!scheduled) { scheduled = true; setTimeout(run, 60); } }
  function start() {
    run();
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.addedNodes && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (node.nodeType === 1 && (String(node.className).indexOf('jdgm') > -1 ||
                (node.querySelector && node.querySelector('.jdgm-write-review-modal')))) {
              schedule(); break;
            }
          }
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();

/* ============================================================
   GSH — Judge.me: ko je odprt obrazec za mnenje, skrij Klaviyo popup
   Klaviyo "Prejmi 15%" popup je na z-index 2147483647 (max) in na mobilnem
   prekrije cel zaslon → obrazec za mnenje se odpre za njim in izgleda "ne dela".
   CSS ga ne more prebiti, zato ga med pisanjem mnenja skrijemo (in vrnemo ob zaprtju).
   ============================================================ */
(function () {
  function klaviyoEls() {
    return document.querySelectorAll('shopify-forms-embed, [class*="klaviyo"], [id*="klaviyo"], [class*="kl-private"]');
  }
  function setHidden(hide) {
    klaviyoEls().forEach(function (e) {
      if (hide) {
        if (!e.hasAttribute('data-gsh-kl-hidden')) {
          e.setAttribute('data-gsh-kl-hidden', '');
          e.style.setProperty('display', 'none', 'important');
        }
      } else if (e.hasAttribute('data-gsh-kl-hidden')) {
        e.removeAttribute('data-gsh-kl-hidden');
        e.style.removeProperty('display');
      }
    });
  }
  function reviewModalOpen() {
    var m = document.querySelector('.jdgm-write-review-modal');
    return !!(m && getComputedStyle(m).display !== 'none');
  }
  var last = null;
  function tick() {
    var open = reviewModalOpen();
    if (open !== last) { last = open; setHidden(open); }
  }
  setInterval(tick, 350); // preprosto in robustno: pokrije vse načine odpiranja/zapiranja
})();
